import http from '@/api/common'

export default {
  getUsersByLocation (params) {
    return http.get('users/getbylocation', { params })
  },
  createUser (user) {
    return http.post('users/create', user)
  },
  updateUser (user) {
    return http.post('users/update', user)
  },
  deleteUser (user) {
    return http.post('users/delete', user)
  },
  getUser (userID) {
    return http.get(`users/get?id=${userID}`)
  },
  getRoles () {
    return http.get('users/getroles')
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/users.js